module.exports = {
      id: "arrow-left-usage",
      viewBox: "0 0 10.153 10",
      url: "/" + "sprite.67d9a3e87988b596c0329bae93bfba4b.svg#arrow-left",
      toString: function () {
        return this.url;
      }
    }